import * as yup from 'yup';

export const validations = yup.object().shape({
  code: yup
    .string()
    .required('O motivo do cancelamento é obrigatório'),
  reason: yup
    .string()
    .when('code', (code, schema) =>
      +code == 9
        ? schema
            .required('A justificativa é obrigatória')
            .min(15, 'A justificativa precisa ter no mínimo 15 caracteres')
        : schema
    )
});
